import React, { createContext, useContext, useEffect, useState } from 'react';
import { axiosWithAuth } from '../services/api';
import { useAuth } from './AuthContext.js';
import { auth } from '../firebase';

const FicharioContext = createContext();

export const useFichario = () => useContext(FicharioContext);

export const FicharioProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid;

  const [fichario, setFichario] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modoLogin, setModoLogin] = useState(false);
  const [needCaptcha, setNeedCaptcha] = useState(false);
  const [captchaValidated, setCaptchaValidated] = useState(false);

  const fetchFichario = async (token = null) => {
    if (!uid) return;


    try {
      setLoading(true);
      setError(null);
      const api = await axiosWithAuth();
      const config = token ? { headers: { 'X-Captcha-Token': token } } : {};
      const { data } = await api.get('/user/me', config);

      setFichario(data);
      setNeedCaptcha(false);
      setCaptchaValidated(!!token);

    } catch (err) {
      setError(err);
      //console.error('Erro ao buscar dados do usuário:', err);
      if (err.response?.status === 401) {
        await auth.signOut();
        setFichario(null);
      } else if (err.response?.status === 429 && err.response.data?.requireCaptcha) {
        setNeedCaptcha(true);
      } else {
        setError('Erro ao carregar dados do usuário. Tente novamente.');
      }

    } finally {
      setLoading(false);
    }
  };


  const validateCaptchaAndFetch = async (token) => {
    if (!token) return;
    try {
      await fetchFichario(token);
    } catch (err) {
      //console.error('Erro ao validar CAPTCHA:', err);
    }
  };


  // Busca automaticamente quando muda o uid ou se fichario estiver vazio
  useEffect(() => {
    if (!uid) {
      setFichario(null);
      return;
    }
    if ((!fichario || !fichario.compra) && !needCaptcha) {
      fetchFichario();
    }
  }, [uid]);


  return (
    <FicharioContext.Provider value={{         
        fichario,
        setFichario,
        loading,
        error,
        needCaptcha,
        setNeedCaptcha,
        captchaValidated,
        validateCaptchaAndFetch,
        modoLogin,
        setModoLogin,
        fetchFichario
        }}>
      {children}
    </FicharioContext.Provider>
  );
};
